import React from 'react';
import { Toolbar } from '@mui/material';
import {
  nativePageComponentMap,
  isNativePage
} from '../constants/nativePageComponents';
import { useNavigation } from '../constants/navigation';
import { RetoolPage } from '../constants/retoolPage';
import { DashboardContentProps } from '../types';
import AdminHome from './AdminHome';
import DashboardBreadcrumbs from './DashboardBreadcrumbs';
import DashboardGrid from './DashboardGrid';
import { DashboardContainer } from './styled';

const DashboardContent = ({
  open,
  selectedPage,
  setSelectedPage,
  closeDropdown,
  schoolConfig
}: DashboardContentProps) => {
  const NAVIGATION = useNavigation(schoolConfig);

  const findParentAndChildTitle = () => {
    for (const nav of NAVIGATION) {
      const child = nav.children?.find((child) => child.value === selectedPage);
      if (child) {
        return { parentTitle: nav.title, childTitle: child.title };
      }
    }

    return { parentTitle: null, childTitle: null };
  };

  const { parentTitle, childTitle } = findParentAndChildTitle();

  const getValidRetoolPage = (
    menuSelection: string
  ): RetoolPage | undefined => {
    return Object.values(RetoolPage).includes(menuSelection as RetoolPage)
      ? (menuSelection as RetoolPage)
      : undefined;
  };

  const retoolPage = getValidRetoolPage(selectedPage) || '';

  const renderContent = () => {
    if (selectedPage === 'Dashboard') {
      return (
        <AdminHome
          setSelectedPage={setSelectedPage}
          closeDropdown={closeDropdown}
          schoolConfig={schoolConfig}
        />
      );
    }
    if (isNativePage(selectedPage)) {
      const Component = nativePageComponentMap[selectedPage];
      return <Component />;
    }
    return <DashboardGrid selectedPage={retoolPage} />;
  };

  return (
    <DashboardContainer open={open}>
      <Toolbar />
      <DashboardBreadcrumbs
        selectedPage={childTitle}
        parentCategory={parentTitle}
        setSelectedPage={setSelectedPage}
        closeDropdown={closeDropdown}
      />
      {renderContent()}
    </DashboardContainer>
  );
};

export default DashboardContent;
